/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {finishWebAuthnAuthentication} from '../api'

export const useMutationFinishWebAuthnAuthentication = createReactQueryMutationHook('finishWebAuthnAuthentication', finishWebAuthnAuthentication)
